const Logo = ({
  width = 200,
  height = 38,
  ...rest
}: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg width={width} height={height} viewBox="0 0 400 76" {...rest}>
      <defs id="defs34">
        <rect
          x="35.374524"
          y="1.1788015"
          width="163.26823"
          height="35.97667"
          id="rect248"
        />
        <rect
          x="35.374523"
          y="1.1788015"
          width="28.96704"
          height="34.610613"
          id="rect248-7"
        />
      </defs>
      <text
        transform="matrix(2.1768629,0,0,2.1768629,-3.6143566,4.8736603)"
        id="text246"
        style={{
          fontSize: '26.6667px',
          whiteSpace: 'pre',
          fill: '#1C4ED9',
        }}
      >
        <tspan x="35.375" y="24.773467" id="tspan499">
          <tspan style={{ fontFamily: 'DejaVu Serif' }} id="tspan497">
            Gaïamundi
          </tspan>
        </tspan>
      </text>
      <g
        id="Layer_1"
        transform="matrix(2.9937644,0,0,2.9937644,-0.70475605,2.323416)"
        style={{
          fill: '#1C4ED9',
        }}
      >
        <g id="g410">
          <path
            d="m 12,5 c 3.859,0.001 7,3.142 7,7.001 C 19,15.859 15.859,18.999 12,19 8.141,19 5,15.86 5,12.001 5,8.142 8.141,5.001 12,5 M 12,3 C 7.029,3.001 3,7.03 3,12.001 3,16.971 7.029,21 12,21 16.97,20.999 21,16.97 21,12.001 21,7.03 16.971,3.001 12,3 Z"
            id="path408"
          />
        </g>
        <path
          d="M 16.182,7.819 C 16.053,7.691 15.867,7.641 15.691,7.692 L 9.74,9.398 C 9.574,9.446 9.445,9.575 9.398,9.741 l -1.707,5.951 c -0.051,0.175 -0.002,0.363 0.127,0.491 0.095,0.095 0.223,0.146 0.354,0.146 0.045,0 0.092,-0.006 0.138,-0.02 l 5.95,-1.708 c 0.165,-0.047 0.295,-0.177 0.342,-0.343 l 1.707,-5.949 c 0.05,-0.173 0.002,-0.361 -0.127,-0.49 z m -7.282,7.282 1.383,-4.817 3.434,3.435 z"
          id="path412"
        />
      </g>
    </svg>
  );
};

export default Logo;
